import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesGeneralTranslationsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-general-translations',
	path: '/secure/admin/ViewTranslations!default.jspa',
};
